import React, { useEffect, useRef, useCallback  } from "react";
import { toast, ToastContainer } from "react-toastify";

// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { anneeAdded, anneeUpdated, anneeGetById } from "../../../Redux/anneeReduce";
import { useTranslation } from 'react-multi-lang'
import { useDispatch } from "react-redux";

function AjouterAnnee({client}) {
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  const t = useTranslation();
  if (isNaN(location.id) === true) document.title = t("Annee.add");
  else document.title = t("Annee.update");
  const [annee, setAnnee] = React.useState("");
  const [id, setId] = React.useState(0);
  const saveCalled = useRef(false);
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }

  function submitForm(event) {
    if (annee != "") {
      if (isNaN(location.id) === true) {

        if (saveCalled.current) return;
        saveCalled.current = true;
        dispatch(anneeAdded({ annee, id })).then((e) => {

          if (e.payload == true) {
            notify(1, t("add_txt"));
            setTimeout(async () => {
              navigate.push(client+'/listAnnee');
            }, 1000);
          } else {
            notify(2, t("problem"));
            saveCalled.current = false;
          }
        })

      } else {
        if (saveCalled.current) return;
        saveCalled.current = true;
        dispatch(anneeAdded({ annee, id })).then((e) => {
          if (e.payload == true) {
            notify(1, t("update_txt"));
            setTimeout(async () => {
              navigate.push(client+'/listAnnee');
            }, 1000);
          } else {
            notify(2, t("problem"));
            saveCalled.current = false;
          }
        })
          .catch((error) => {
            notify(2, t('erreur_add'));
            console.error('Error updating annee:', error);
          });
      }
    } else {
      notify(2, t('Annee.required'));
    }
  }

  useEffect(() => {
    async function getAnnee() {
      if (isNaN(location.id) === false) {
        var annee = await dispatch(anneeGetById(location.id));
        var entities = annee.payload;
        if (entities === false) {
          navigate.push(client+'/listAnnee');
        }
        else {
          setAnnee(entities.annee);
          setId(location.id);
        }
      }
    }
    getAnnee();
  }, [location.id, dispatch, navigate]);

  function listeAnnee() {
    navigate.push(client+'/listAnnee');
  }
  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={listeAnnee}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t('list')}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">
                      {typeof location.id == "undefined"
                        ? t('Annee.add')
                        : t('Annee.update')}
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>{t('year')} * </label>
                          <Form.Control
                            value={annee}
                            placeholder={t('year')}
                            type="number"
                            onChange={(value) => {
                              setAnnee(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Button
                      className="btn-fill pull-right"
                      type="button"
                      variant="info"
                      onClick={submitForm}
                    >
                      {t('save')}
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

export default AjouterAnnee;
